module.exports = {"serverWebsocketUrl":"wss://arm-part.herokuapp.com","firebase":{"apiKey":"AIzaSyCal6_2njqdnRoBvOiyMIVzpGyQyRgl3Cg","authDomain":"arm-part-staging.firebaseapp.com","databaseURL":"https://arm-part-staging.firebaseio.com","projectId":"arm-part-staging","storageBucket":"arm-part-staging.appspot.com","messagingSenderId":"900830944876"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 179
// module chunks = 0